"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip"));
var _uiTheme = require("@kyruus/ui-theme");
const ChipComponent = (0, _uiTheme.withMuiThemeAdapter)(_Chip.default);

// This is silly, but it optimizes for developers.
// react-docgen can't find the propTypes unless it
// sees a component defininition.
const Chip = props => /*#__PURE__*/_react.default.createElement(ChipComponent, props);
// PropTypes taken from material-ui https://material-ui.com/api/chip/
Chip.propTypes = {
  /**
   * The content of the label.
   */
  label: _propTypes.default.node,
  /**
   * The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
  /**
   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
   */
  onDelete: _propTypes.default.func,
  /**
   * Override the default delete icon element. Shown only if onDelete is set.
   */
  deleteIcon: _propTypes.default.element,
  /**
   * Avatar element.
   */
  avatar: _propTypes.default.element,
  /**
   * If true, the chip will appear clickable, and will raise when pressed, even if the onClick property is not defined. This can be used, for example, along with the component property to indicate an anchor Chip is clickable.
   */
  clickable: _propTypes.default.bool
};
Chip.defaultProps = {
  component: 'div',
  clickable: false
};
var _default = exports.default = Chip;
Chip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Chip",
  "props": {
    "component": {
      "defaultValue": {
        "value": "'div'",
        "computed": false
      },
      "description": "The component used for the root node. Either a string to use a DOM element or a component.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "func"
        }, {
          "name": "object"
        }]
      },
      "required": false
    },
    "clickable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, the chip will appear clickable, and will raise when pressed, even if the onClick property is not defined. This can be used, for example, along with the component property to indicate an anchor Chip is clickable.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "description": "The content of the label.",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onDelete": {
      "description": "Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "deleteIcon": {
      "description": "Override the default delete icon element. Shown only if onDelete is set.",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "avatar": {
      "description": "Avatar element.",
      "type": {
        "name": "element"
      },
      "required": false
    }
  }
};